import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { validationMessages } from 'constants/validation'

import { FormGroup, TextField } from '@mui/material'

import { Section } from 'components/controls/section'

import { TargetListResult } from 'interface/search/targetList'
import { useCallback } from 'react'

const {
  Required,
  TooLongLength,
  TooShortLength,
} = validationMessages

const formSchema = yup.object().shape({
  listName: yup
		.string()
		.required(Required)
		.min(3, TooShortLength(3))
		.max(100, TooLongLength(100)),
	description: yup
		.string()
		.nullable()
})

export const useTargetListForm = (
  targetList?: TargetListResult
) => {
	const form = useForm({
		defaultValues: targetList ? {
			listName: targetList.listName,
			description: targetList.description ?? '',
		} : {
			listName: '',
			description: '',
		},
		//mode: 'onChange',
		criteriaMode: 'all',
		resolver: yupResolver(formSchema)
	})
  const { setValue } = form
	const setFileTitle = useCallback(
		(title: string) => {
			setValue("listName", title, { shouldValidate: true })
		},
		[setValue]
	)
	return {
		...form,
		setFileTitle
  }
}

export const TargetListForm = ({
	control,
	formState: { errors }
}: ReturnType<typeof useTargetListForm>) => {
  return (
		<FormGroup>
			<Section label='タイトル' labelWidth='5em' labelProps={{ paddingY: 2 }}>
				<Controller
					control={control}
					name="listName"
					render={({ field }) => (
						<TextField
							{...field}
							variant="outlined"
							size="small"
							error={!!errors.listName}
							helperText={errors.listName ? errors.listName.message : ''}
						/>
					)}
				/>
			</Section>
			<Section label='メモ' labelWidth='5em' labelProps={{ paddingY: 2 }}>
				<Controller
					control={control}
					name="description"
					render={({ field }) => (
						<TextField
							{...field}
							hiddenLabel
							fullWidth
							variant='outlined'
							size='small'
							multiline
							error={!!errors.description}
							helperText={errors.description ? errors.description.message : ''}
						/>
					)}
				/>
			</Section>
		</FormGroup>
  )
}
